import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { assignSZLTByIdFailed, assignSZLTByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* assignSZLTById(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/user/role`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    if (dataResponse.status === OK) {
      yield put(assignSZLTByIdSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(assignSZLTByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(assignSZLTByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
